import { Button, Input, InputNumber, Select } from "@appkit4/react-components";
import { useEffect, useState } from "react";
import toast from "../../../components/DismissibleToast";
import sqlService from "../../../services/sqldatabase/sqldatabase.service";
import "../home.scss";
import { getIdByName, getNamesFromList } from "../util/homeUtil";

const NewGroupModal = ({ groupList, fetchGroups, resetForm, setResetForm }) => {
  const [selectedGroupName, setSelectGroupName] = useState();
  const [selectedGroupId, setSelectedGroupId] = useState();
  const [numOfCopies, setNumOfCopies] = useState(1);
  const [customNameSuffix, setCustomNameSuffix] = useState();
  const [buttonsDisabled, setButtonsDisabled] = useState(false);

  useEffect(() => {
    if (resetForm) {
      setSelectGroupName("");
      setSelectedGroupId("");
      setCustomNameSuffix("");
      setNumOfCopies(1);
      setResetForm(false);
    }
  }, [resetForm]);

  const toastPromise = async (inputFunction) => {
    if (selectedGroupId && numOfCopies) {
      setButtonsDisabled(true);
      const promise = inputFunction(
        selectedGroupId,
        selectedGroupName,
        numOfCopies,
        customNameSuffix,
      ).then((response) => {
        if (response.status !== 200) {
          // Return an object that includes the error message instead of throwing an error
          return {
            error: true,
            message: `Error: Status ${response.status} - ${response.err}`,
          };
        }
        return response;
      });

      return toast
        .promise(promise, {
          loading: `Creating ${numOfCopies} copies of group: ${selectedGroupName}`,
          success: (response) => {
            // Check if there was an error
            if (response.error) {
              throw new Error(response.message);
            }
            setSelectGroupName("");
            setSelectedGroupId("");
            setCustomNameSuffix("");
            setNumOfCopies(1);
            fetchGroups();
            return `Created ${numOfCopies} copies of group: ${selectedGroupName}`;
          },
          error: (response) => {
            // Show the error message in the toast
            return `Failed to create copies. ${response?.error?.err}`;
          },
        })
        .then(() => setButtonsDisabled(false));
    }
  };

  const generateCopies = async () => {
    toastPromise(sqlService.postCreateGroupCopies);
  };

  return (
    <div>
      <div className="flex-space-between">
        <Select
          placeholder={"Select Group"}
          value={selectedGroupName}
          className="col"
          style={{ width: "35rem" }}
          searchable
          data={getNamesFromList(groupList)}
          dropdownRenderMode={"portal"}
          onSelect={(groupName) => {
            setSelectGroupName(groupName);
            setSelectedGroupId(getIdByName(groupName, groupList));
          }}
        ></Select>
        <div style={{ flex: "1 0 10px" }}></div>
        <Input
          title={"(optional) name suffix"}
          value={customNameSuffix}
          onChange={(val) => {
            setCustomNameSuffix(val);
          }}
          style={{ width: "12rem" }}
        ></Input>
        <div style={{ flex: "1 0 10px" }}></div>
        <InputNumber
          title={"number of copies"}
          value={numOfCopies}
          onChange={(val) => {
            setNumOfCopies(val);
          }}
          style={{ width: "12rem" }}
        ></InputNumber>
        <div style={{ flex: "1 0 10px" }}></div>
        <Button
          className="col-2 m-1"
          disabled={
            !selectedGroupName ||
            !numOfCopies ||
            numOfCopies < 0 ||
            buttonsDisabled
          }
          onClick={() => generateCopies()}
        >
          Copy Group
        </Button>
      </div>
    </div>
  );
};

export default NewGroupModal;
